import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


	const __default__ = { name: 'VDivider' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
        soft: {
            type: Boolean,
            default: false
        }
    },
  setup(__props) {

/*eslint-disable*/
    const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("hr", {
    role: "presentation",
    class: _normalizeClass([
			'w-full border-t',
			__props.soft && 'border-zinc-950/5 dark:border-white/5',
			!__props.soft && 'border-zinc-950/10 dark:border-white/10'
		])
  }, null, 2))
}
}

})